import { Component, OnInit, Input } from '@angular/core';
import { Document } from '../../../../shared/sdk';
import { DocumentService } from '../../../../documents/document.service';

@Component({
  selector: 'app-document-view-status',
  templateUrl: './document-view-status.component.html',
  styleUrls: ['./document-view-status.component.css']
})
export class DocumentViewStatusComponent implements OnInit {
  @Input() doc: Document;

  constructor(
    private documentService: DocumentService,
  ) { }

  ngOnInit() {
  }

  hasPayments(type: string): boolean {
    return this.documentService.has.payment.indexOf(type) !== -1;
  }

  isSent(document: Document): boolean {
    return this.documentService.isSent(document);
  }

}
